module.exports = __webpack_public_path__ + "img/newchris-46.fff7f24d.jpg";